import { Link } from "react-router-dom";
import { Heart, Sprout, Sun, HandHeart } from "lucide-react";

const ABOUT_IMG = "https://images.unsplash.com/photo-1475070929565-c985b496cb9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100";

const VALUES = [
  { icon: Heart, t: "Kindness over extravagance", d: "We believe a sincere gesture matters more than a grand one." },
  { icon: Sprout, t: "Hope in every season", d: "Sympathy, recovery, celebration, or just because — we're here for it all." },
  { icon: HandHeart, t: "Made by hand", d: "Every box is assembled with care and finished with a handwritten note." },
  { icon: Sun, t: "Welcoming to all", d: "Faith-inspired encouragement, offered with an open and gentle heart." },
];

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12 py-20">
      <div className="grid lg:grid-cols-[55%_45%] gap-12 lg:gap-16 items-center">
        <div>
          <span className="gh-overline">About Hope &amp; Favor</span>
          <h1 className="font-heading text-5xl sm:text-6xl text-[#3A3632] mt-4 leading-[1.05]">Helping people feel seen, encouraged &amp; supported.</h1>
          <div className="gh-hairline my-7 max-w-[120px]" />
          <p className="text-lg text-[#6B655F] leading-relaxed font-light">
            Hope &amp; Favor exists for the moments when words feel hard to find. We create curated gift boxes that say, gently and beautifully, <span className="font-hand text-2xl text-[#C4A4A4]">"I see you, and you matter."</span>
          </p>
        </div>
        <div className="gh-fade-up flex justify-center">
          <div className="gh-octagon w-72 h-72 sm:w-80 sm:h-80 overflow-hidden ring-1 ring-[#D9CBA0] p-1.5 bg-[#D9CBA0]/40">
            <img src={ABOUT_IMG} alt="A calm, peaceful moment" className="gh-octagon w-full h-full object-cover" />
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-px bg-[#D9CBA0]/30 border border-[#D9CBA0]/30 mt-20">
        {VALUES.map((v, i) => (
          <div key={v.t} className="bg-[#FAF7F2] p-10 gh-fade-up" style={{ animationDelay: `${i * 60}ms` }}>
            <div className="h-14 w-14 gh-octagon bg-[#8E9A86]/12 flex items-center justify-center mb-5"><v.icon className="h-6 w-6 text-[#8E9A86]" /></div>
            <h3 className="font-heading text-2xl text-[#3A3632]">{v.t}</h3>
            <p className="text-[#6B655F] mt-2 leading-relaxed">{v.d}</p>
          </div>
        ))}
      </div>

      <div className="bg-[#8E9A86] p-12 sm:p-16 mt-20 text-center relative">
        <div className="absolute inset-4 border border-[#D9CBA0]/50 pointer-events-none" />
        <p className="font-hand text-3xl sm:text-4xl text-white leading-relaxed max-w-2xl mx-auto relative">Thoughtful gestures matter. We are so grateful you are here.</p>
        <Link to="/our-story" data-testid="about-story-btn" className="inline-block mt-8 bg-white text-[#3A3632] rounded-full px-8 py-3.5 font-light tracking-wide hover:bg-[#FAF7F2] transition-colors relative">Read our story</Link>
      </div>
    </div>
  );
}
